<template>
  <div class="main-nav">
    <b-navbar type="dark" variant="primary">
      <b-navbar-brand to="/">{{ $t("navbar.brand") }}</b-navbar-brand>

      <b-navbar-nav v-if="isLoggedIn">
        <b-nav-item to="/sites" :active="$route.path === '/sites'">{{
          $t("navbar.sites")
        }}</b-nav-item>
        <b-nav-item to="/profile" :active="$route.path === '/profile'">{{
          $t("navbar.profile")
        }}</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown v-if="isLoggedIn" right toggle-class="pad-0">
          <template v-slot:button-content>
            <b-avatar variant="primary" :src="user.avatarUrl" alt="" />
          </template>
          <b-dropdown-item to="/profile">{{
            $t("navbar.profile")
          }}</b-dropdown-item>
          <b-dropdown-item
            :href="`mailto:hi@ifconfiger.com?subject=CertsMonitor-${user.uid}`"
            >{{ $t("navbar.help") }}</b-dropdown-item
          >
          <b-dropdown-item @click="logout()">{{
            $t("navbar.sign-out")
          }}</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item to="/login" v-else>
          {{ $t("navbar.login") }}
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "Navbar",
  computed: {
    ...mapState("user", ["user"]),
    ...mapGetters("user", ["isLoggedIn", "isAdmin"]),
    ...mapActions("user", ["logout"])
  }
};
</script>

<style lang="scss">
.main-nav {
  .pad-0 {
    padding: 0;
  }
}
</style>
